import { useEffect, useRef } from 'react';

/**
 * Custom hook to check if a component is still mounted
 * Useful when there are async operations being performed on a component,
 * resulting in setState or similar calls happen after a component is unmounted
 */
export const useIsMounted = () => {
    const isMounted = useRef(false);

    useEffect(() => {
        isMounted.current = true;

        return () => {
            isMounted.current = false;
        };
    }, []);

    return () => isMounted.current;
};
